// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rWyo","content":"styles_content__3_FhL","row":"styles_row__3UVNq","footer":"styles_footer__jv1P4","phraseLength":"styles_phraseLength__1eFwc"};